/* istanbul ignore file */
import { TextField } from 'framework/ui/field';
import SkillBasedQueueSearchLinkField from 'domain/gpo/skillBasedQueue/shared/SkillBasedQueueSearchLinkField';
import CopySkillBasedQueueButton from 'domain/gpo/skillBasedQueue/shared/button/CopySkillBasedQueueButton';
import { BudgetLinkField } from 'domain/shared/budget';
import { DISABLED_PERMISSION } from 'domain/gpo/skillBasedQueue/shared/skillBasedQueueService';
import { DataGridLayout } from 'framework/list';

const SkillBasedQueueListLayout = () => {
  return (
    <DataGridLayout
      tableWrapperClassName="sbq-table-wrapper"
      buttons={[<CopySkillBasedQueueButton source="id" permissionToCheck={DISABLED_PERMISSION} variant="outlined" />]}
    >
      <SkillBasedQueueSearchLinkField source="id" idSource="id" label="ID" isSortable />
      <TextField label="Name" source="name" nameSource="name" isSortable />
      <BudgetLinkField label="Default budget" source="defaultBudgetId" nameSource="defaultBudgetName" />
    </DataGridLayout>
  );
};

export default SkillBasedQueueListLayout;
